import React from "react";
import { EMPTY_STRING } from "../../../constants";

const ProfileImage = React.memo(({ imageUrl = EMPTY_STRING, alt = "PI" }) => {
  const src = imageUrl
    ? `${process.env.REACT_APP_S3_BASE_URL_PORTFOLIO}/${imageUrl}`
    : EMPTY_STRING;

  return (
    <div className="position-relative circle-wrapper">
      <img
        src={src}
        alt={alt}
        className="img-fluid rounded-circle profile-img"
      />
    </div>
  );
});

export default ProfileImage;